export default "__VITE_ASSET__CMGz4hVf__"